/**
 * Mensaje para el usuario cuando falla el guardado de una cartera modelo (crear o editar): el del backend si lo envía
 * y, si no, uno según el código de respuesta.
 */
export const getSaveModelWalletErrorMessage = (saveError: any): string =>
{
    const status: number | undefined = saveError?.response?.status;
    const data = saveError?.response?.data;

    if(typeof data === "string" && data.trim() !== "")
    {
        return data;
    }
    if(status === undefined)
    {
        return "No se ha podido conectar con el servidor para guardar la cartera modelo. Revisa tu conexión e inténtalo de nuevo.";
    }
    if(status === 401 || status === 403)
    {
        return "No tienes permiso para guardar esta cartera modelo o tu sesión ha caducado. Vuelve a iniciar sesión e inténtalo de nuevo.";
    }
    if(status === 404)
    {
        return "No se ha encontrado el plan o la cartera modelo que intentas guardar.";
    }
    return `No se ha podido guardar la cartera modelo (error ${status}). Por favor, inténtalo de nuevo más tarde.`;
};
